import { isFeedbackEnabled } from './feedbackPrefill.js';
import { registerPostCaptureHook } from './hooks.js';

let registered = false;

// Registers the feedback widget as a post-capture hook, so `init.ts` stays
// unaware of this feature. The `feedback.js` chunk itself is only pulled in
// when a captured event actually needs it (flag-gated, see FeedbackFlagSync).
export function registerFeedbackHook() {
  if (registered) {
    return;
  }
  registered = true;

  registerPostCaptureHook((event) => {
    if (!isFeedbackEnabled() || !event.event_id) {
      return;
    }
    const eventId = event.event_id;
    void import('./feedback.js')
      .then(({ openFeedbackForEvent }) => openFeedbackForEvent(eventId))
      .catch(() => {
        /* chunk-load failure — safe to ignore */
      });
  });
}
